import {Component, OnInit, ViewChild} from '@angular/core';
import {animate, state, style, transition, trigger} from "@angular/animations";
import {MatTableDataSource} from "@angular/material/table";
import {
  Config,
  getConfig,
  getSelectedBusinessUnit,
  initialConfigState,
  toggleLoading, updateDealId,
  updateEditingBusinessUnit
} from "../../../redux";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort, Sort} from "@angular/material/sort";
import {Store} from "@ngrx/store";
import {Router} from "@angular/router";

import {ToastrService} from "ngx-toastr";
import {BusinessUnitService} from "../../services";
import {LookupService} from "../../../../services";
import {IBusinessUnit} from "../../models";
import {Subscription} from "rxjs";
import {HttpErrorResponse} from "@angular/common/http";
import {MatDialog} from "@angular/material/dialog";
import {BusinessUnitModalComponent} from "../business-unit-modal/business-unit-modal.component";
import {UtilService} from "../../../shared/services";
import {ModalSize} from "../../../shared/services/util/util.service";
import {addBusinessUnits} from "../../../redux/stores/business-unit/business-unit.actions";
import { DataService } from 'src/app/services/data/data.service';

@Component({
  selector: 'app-business-units-list',
  templateUrl: './business-units-list.component.html',
  styleUrls: ['./business-units-list.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class BusinessUnitsListComponent implements OnInit {

  config$: Subscription = new Subscription();
  selectedBusinessUnit$: Subscription = new Subscription();

  dataSource: MatTableDataSource<IBusinessUnit> = new MatTableDataSource();

  buList: IBusinessUnit[] = [];
  sortedBusinessUnits: IBusinessUnit[] = [];
  config: Config = initialConfigState;

  columnsToDisplay = ['DisplayName', 'Type', 'Submissions', 'Employees', 'Status', 'Created', 'Actions'];

  businessUnitFilterTypes: {key: string, value: string}[] = [
    {key: 'PENDING', value: 'Pending'},
    {key: 'APPROVED', value: 'Approved'},
    {key: 'AUTO_APPROVED', value: 'Auto Approved'},
    {key: 'DECLINED', value: 'Declined'},
    {key: 'ARCHIVED', value: 'Archived'},
  ]
  selectedBusinessUnitFilterType: string[] = [
    'PENDING', 'APPROVED', 'AUTO_APPROVED'
  ];

  expandedElement: IBusinessUnit | null = {} as IBusinessUnit;
  @ViewChild(MatPaginator) paginator?: MatPaginator;
  @ViewChild(MatSort) sort?: MatSort;

  constructor(private store: Store,
              private router: Router,
              private businessUnitService: BusinessUnitService,
              private toastr: ToastrService,
              private lookups: LookupService,
              private dialog: MatDialog,
              private dataService: DataService,
              public util: UtilService
  ) {

    this.dataSource = new MatTableDataSource();
  }

  ngOnInit(): void {
    this.store.dispatch(updateEditingBusinessUnit({businessUnit: {} as IBusinessUnit}));

    this.subscribeToDatasource();
  }

  /**
   * Business Unit Modal
   */
  openBusinessUnitModal() {
    // console.log("this.util.getModalWidth(ModalSize.MEDIUM)", this.util.getModalWidth(ModalSize.MEDIUM));

    this.dialog.open(BusinessUnitModalComponent, {
      height: 'auto',
      width: this.util.getModalWidth(ModalSize.MEDIUM),
      panelClass: 'rondeivu-modal'
    })
    .afterClosed().subscribe((result: IBusinessUnit) => {
      console.log("Create Business Unit Modal result:", result);
      if (!!result) {
        console.log("Creating business unit...");
        this.store.dispatch(toggleLoading({loading: true}));
        this.businessUnitService.addBusinessUnit(result).subscribe({
          next: res => {
            this.subscribeToDatasource();
            this.store.dispatch(toggleLoading({loading: false}));
            this.toastr.success('Business Unit Added!', $localize`:@@companyName:Rondeivu`);
          }, error: (error: HttpErrorResponse) => {
            this.store.dispatch(toggleLoading({loading: false}));
            this.toastr.error('Unable to add business unit!', $localize`:@@companyName:Rondeivu`);
          }
        });
      }
    });
  }

  subscribeToDatasource() {
    // console.log("Fetching Business Units...");
    this.store.dispatch(updateDealId({dealId: ''}));
    this.store.dispatch(toggleLoading({loading: true}));
    //fetch the bu
    this.businessUnitService.getBusinessUnits().subscribe({
      next: (businessUnits: IBusinessUnit[]) => {
        this.buList = businessUnits;
        // console.log("Fetched Business Units: ", businessUnits);
        // this.store.dispatch(addBusinessUnits({businessUnits: this.buList}));

        this.dataSource.data = businessUnits;

        if (!!this.sort) {
          this.dataSource.sort = this.sort;
        }

        this.dataSource.filterPredicate = (data: IBusinessUnit, filter: string) => {
          const criteria = JSON.parse(filter);

          const matchesName =
            !criteria.searchText ||
            data.displayName
              .toLowerCase()
              .includes(criteria.searchText.toLowerCase());

          const matchesStatus =
            criteria.statuses.length === 0 ||
            criteria.statuses.includes(data.status);

          return matchesName && matchesStatus;
        };


        this.dataSource.sortingDataAccessor = (item: any, property: string) => {  
          const value = item[property as keyof any];

          if (typeof value === 'string') {
            return value.toLowerCase();
          }
          
          if (typeof value === 'number') {
            return value;
          }
          
          if (value instanceof Date) {
            return value.getTime();
          }
          
          return value;
        };


        this.applyTypeFilter('');

        // this.initDataSource();
        this.store.dispatch(toggleLoading({loading: false}));
      }, error: err => {
        this.toastr.error("Unable to get business units!", $localize`:@@companyName:Rondeivu`);
        this.store.dispatch(toggleLoading({loading: false}));
      }
    });
  }

  viewBusinessUnit(bu: IBusinessUnit) {
    this.store.dispatch(toggleLoading({loading: true}));
    this.store.dispatch(updateEditingBusinessUnit({businessUnit: bu}));
    this.router.navigate(['/' + this.dataService.getBuSlug() + '/business-units/' + bu.businessUnitId + '/information']).then(() => {
      setTimeout(() => {
        this.store.dispatch(toggleLoading({loading: false}));
      }, 700);
    });

  }

  viewHistory(bu: IBusinessUnit) {
    this.store.dispatch(toggleLoading({loading: true}));
    this.router.navigate(['/' + this.dataService.getBuSlug() + '/history/businessunits'], {queryParams: {id: bu.businessUnitId}}).then(() => {
      setTimeout(() => {
        this.store.dispatch(toggleLoading({loading: false}));
      }, 700);
    });
  }

  
  applyTypeFilter(type: string) {
    // console.log("Applying type filter:", type);
    this.dataSource.filter = JSON.stringify({
      searchText: '',
      statuses: this.selectedBusinessUnitFilterType
    });

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    
    this.dataSource.filter = JSON.stringify({
      searchText: filterValue,
      statuses: this.selectedBusinessUnitFilterType
    });

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

}
